package fr.manyverse.app.domain.model

data class GameTableInfo(
    val table: GameTable,
    val role: MemberRole
)
